import { render, staticRenderFns } from "./BaseWorkspaceLayout.vue?vue&type=template&id=24407147&scoped=true&"
import script from "./BaseWorkspaceLayout.vue?vue&type=script&lang=js&"
export * from "./BaseWorkspaceLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseWorkspaceLayout.vue?vue&type=style&index=0&id=24407147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24407147",
  null
  
)

export default component.exports